import React from 'react';
import { Button } from 'antd';
import SidebarPanelIcon from './SidebarPanelIcon.jsx';

export function StandaloneSidebarToggleButton({ onToggle, show, sidebarCollapsed, themeTokens }) {
  if (!show) {
    return null;
  }
  return (
    <Button
      aria-label={sidebarCollapsed ? '展开左侧栏' : '收起左侧栏'}
      icon={<SidebarPanelIcon />}
      onClick={onToggle}
      size="small"
      style={{
        borderRadius: 10,
        color: themeTokens.textPrimary,
        height: 32,
        width: 32,
      }}
      type="text"
    />
  );
}

export function StandaloneInlineSidebar({ children, show, themeTokens }) {
  if (!show) {
    return null;
  }
  return (
    <aside aria-label="左侧导航"
      style={{
        backgroundColor: themeTokens.sidebarBg,
        borderRight: `1px solid ${themeTokens.divider}`,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'hidden',
        transition: 'width 220ms cubic-bezier(0.2, 0, 0, 1)',
        width: '100%',
      }}
    >
      {children}
    </aside>
  );
}
